export default "__VITE_ASSET__BWox22Q5__"